<template>
  <div class="bg-white shadow-md px-3 rounded-md">
        <div class="relative" v-for="error in uploadedErrors" :key="error.request_id">
            <div class="flex items-center justify-start overflow-hidden mr-12">
                <img class="h-14 w-14 rounded-lg object-cover" :src="getFileUrl(error.file)" />
                <div class="h-20 flex flex-col justify-center w-96">
                    <span class="ml-6 text-sm text-gray-500">{{'Uploading ' + error.name}}</span>
                </div>
                <div class="cursor-pointer flex items-center justify-center absolute right-3" @click="removeFromErrors(error.request_id)">
                    <span class="text-red-500 text-lg mr-6">
                        Upload Failed
                    </span>
                    <div class="text-red-500 mr-8">
                        <ErrorInfo />
                    </div>
                    <div class="text-gray-500">
                        <XIcon class="w-3.5 h-3.5"/>
                    </div>
                </div>
            </div>
        </div>
    <div >
    </div>
    <div class="relative" v-for="uploadedFile in getCurrentUploading()" :key="uploadedFile.request_id">
        <div class="flex items-center justify-start overflow-hidden mr-12">
            <img class="h-14 w-14 rounded-lg object-cover" :onerror="`this.onerror=null; this.src='${IMAGE_PLACEHOLDER}'`" :src="getFileUrl(uploadedFile.file)" />
            <div class="h-20 flex flex-col justify-center w-96">
                <span class="mb-2 ml-6 text-sm text-yank">{{'Uploading ' + uploadedFile.name}}</span>
                <loading-progress
                :indeterminate="true"
                fillDuration="2"
                height="20"
                :size="1500"
                />
            </div>
            <div class="cursor-pointer absolute top-5 right-3 text-gray-500" @click="removeCurrent(uploadedFile.request_id)">
                <XIcon class="w-3.5 h-3.5"/>
            </div>
        </div>
    </div>
    <div v-if="currentUploading.length > 3" class="pb-3 w-full flex items-center justify-center">
      <span class="text-gray-400 font-normal">+ {{ currentUploading.length - 3 }} more uploading</span>
    </div>
  </div>
</template>

<script>
import XIcon from '@/components/svg/XIcon';
import ErrorInfo from '@/components/svg/ErrorInfo';
import { VIDEO_PLACEHOLDER, IMAGE_PLACEHOLDER } from '@/utils/constants';
export default {
  name: "UploadResults",
  components: {
      XIcon,
      ErrorInfo
  },
  props: {
    uploadErrors: Object,
    uploadSuccess: Object,
    currentUploading: {type: Array, default: () => ([])}
  },
  data() {
    return {
      uploadedFiles: [],
      uploadedErrors: [],
      IMAGE_PLACEHOLDER
    };
  },

  mounted() {
      this.uploadedErrors = [];
  },

  methods: {
    getFileUrl(file) {
      if(file && file.type.includes('video')) {
        return VIDEO_PLACEHOLDER;
      }
      return URL.createObjectURL(file);
    },

    getCurrentUploading() {
      return this.currentUploading.length > 3 ? this.currentUploading.slice(0, 3) : this.currentUploading;
    },

    removeCurrent(requestId) {
        this.$emit('removeFromCurrent', requestId);
    },

    removeFromErrors(requestId) {
        this.uploadedErrors = this.uploadedErrors.filter(item => item.request_id != requestId);
        this.$emit('changeCurrentUploadingErrors', this.uploadedErrors.length);
    }
  },

  watch: {
    uploadErrors: {
      handler(uploadErrors) {
        const requestId = uploadErrors.request_id;
        const error = this.currentUploading.find(item => item.request_id == requestId);
        this.uploadedErrors.push(error);
        this.$emit('changeCurrentUploadingErrors', this.uploadedErrors.length);
        this.$emit('removeFromCurrent', requestId);
        setTimeout(() => {
            this.removeFromErrors(requestId);
        }, 3000);
      },
      deep: true,
    },
    uploadSuccess: {
      handler(uploadSuccess) {
        this.$emit('removeFromCurrent', uploadSuccess.request_id);
      },
      deep: true,
    },
  },
};
</script>